import store from "../redux/store";
import { wsMsgSeparatorChar } from "./websocketHelper";
import { updateSymbolInfos, updateSymbolChart, updateSymbolPriceChart, updatePutThroughInfo, updateSymbolTPRLInfos } from "../redux/actions/symbolActions";
import { updateBoardTPRL, updateMarketTPRL } from "../redux/actions/boardMarketdActions";

const arrColor = new Array(
   "", // None
   "clr-ceil",
   "clr-floor",
   "clr-ref",
   "clr-down",
   "clr-up"
);

const arrBoardMarketTPRLField = new Array(
   // "boardCode", //0
   // "marketcode",
   // "boardStatus",
   // "tradingSessionId",
   // "tradSesStatus",
   // "tradingDate", //5
   // "totalTrade",
   // "totalStock",
   // "totalTradedQtty",
   // "totalTradedValue",
   // "totalNormalTradedQtty", //10
   // "totalNormalTradedValue",
   // "totalPtTradedQtty",
   // "totalPtTradedValue",
   // "totalReposTradedQtty",
   // "totalReposTradedValue", //15
   // "pt_TotalBidValue",
   // "pt_TotalOfferValue"
   "boardCode",
   "tradSesStatus",
   "pt_TotalBidValue",
   "totalPtTradedValue",
   "totalPtTradedQtty",
   "pt_TotalOfferValue"
);

export const processMsgMarketTPRL = (message, isInit) => {
   try {
      // console.log(message, "message market TPRL");
      let _old = store.getState().gBoard.marketTRPLInfo;

      let _msgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
      for (let _msgIdx = 0; _msgIdx < _msgs.length; _msgIdx++) {
         if (_msgs[_msgIdx] !== "") {
            const _firstIdx = _msgs[_msgIdx].indexOf(wsMsgSeparatorChar.PropSeparatorChar);
            const _boardCode = _msgs[_msgIdx].substr(0, _firstIdx);
            let _rIndex = _old.findIndex((item) => item.boardCode === _boardCode);
            if (_rIndex < 0) {
               isInit = true;
               _old.push({ boardCode: _boardCode, counter: 0, closePriceHistChart: "", foreignTradeHistChart: "" });
               _rIndex = _old.length - 1;
            }
            //
            let _objTemp = _old[_rIndex];
            let _changed = false;
            const _arrData = _msgs[_msgIdx].substr(_firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);

            for (let _dataIdx = 0; _dataIdx < _arrData.length; _dataIdx++) {
               if (_arrData[_dataIdx] !== "") {
                  let _arrSubData = _arrData[_dataIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
                  const _propIndex = Number(_arrSubData[0]);
                  if (_propIndex < arrBoardMarketTPRLField.length) {
                     let _objProp = arrBoardMarketTPRLField[_propIndex];
                     _objTemp[_objProp] = _arrSubData[1];
                     if (_arrSubData.length >= 3) {
                        _objTemp[_objProp + "_color"] = arrColor[Number(_arrSubData[2])];
                     }
                     _changed = true;
                  }
               }
            }
            //
            if (_changed) {
               _objTemp.counter = _objTemp.counter ?? 0 + 1;
            }
            //
            _old[_rIndex] = _objTemp;
         }
      }
      store.dispatch(updateMarketTPRL(_old, isInit));
   } catch (error) {}
};

//   let _msgs = message.split(wsMsgSeparatorChar.PropSeparatorChar);
//   for (let _msgIdx = 0; _msgIdx < _msgs.length; _msgIdx++) {
//      if (_msgs[_msgIdx] !== "") {
//         const _rIndex = _old.findIndex((_, index) => index === _msgIdx);
//         console.log(_rIndex);
//      }
//   }
